(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-filters"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const urlParams = new URLSearchParams(window.location.search);
    const yearParam = urlParams.get('year');
    const makeParam = urlParams.get('make');
    const modelParam = urlParams.get('model');
    const engineParam = urlParams.get('engine');
    const collectionParam = urlParams.get('collection');

    const cards = document.querySelectorAll('.product-card');
    const countEl = document.querySelector('.results-count');
    const filterCheckboxes = document.querySelectorAll('.filter');
    const grid = document.getElementById('productsGrid');

    const ITEMS_PER_PAGE = 9;
    let currentPage = 1;
    let mobileVisibleItems = ITEMS_PER_PAGE;

    // INIT: mark all as visible
    cards.forEach((card) => card.classList.add('filtered-in'));

    function cleanAndSplit(str) {
      if (!str) return [];
      return str
        .replace(/,+$/, '')
        .split(',')
        .map((val) => val.trim())
        .filter((val) => val !== '');
    }

    function normalize(val) {
      return val ? val.toString().trim().toLowerCase() : '';
    }

    function applyFilters() {
      const activeCollections = Array.from(filterCheckboxes)
        .filter((el) => el.checked)
        .map((el) => el.value);

      let visibleCount = 0;

      cards.forEach((card) => {
        const productYears = cleanAndSplit(card.dataset.years);
        const productMakes = cleanAndSplit(card.dataset.makes);
        const productModels = cleanAndSplit(card.dataset.models);
        const productEngines = cleanAndSplit(card.dataset.engines);

        const productCollections = card.dataset.collections ? card.dataset.collections.trim().split(' ') : [];

        const matchesCollection =
          activeCollections.length === 0 || activeCollections.some((c) => productCollections.includes(c));

        const matchesYear = !yearParam || productYears.some((y) => normalize(y) === normalize(yearParam));

        const matchesMake = !makeParam || productMakes.some((m) => normalize(m) === normalize(makeParam));

        const matchesModel = !modelParam || productModels.some((m) => normalize(m) === normalize(modelParam));

        const matchesEngine = !engineParam || productEngines.some((e) => normalize(e) === normalize(engineParam));

        const isGlobal = card.dataset.global === 'true';
        const merchandiseSelected = activeCollections.includes('merchandise');

        const shouldShow =
          matchesCollection &&
          matchesYear &&
          matchesMake &&
          matchesModel &&
          matchesEngine &&
          !(merchandiseSelected && isGlobal);

        if (shouldShow || (!merchandiseSelected && isGlobal)) {
          card.classList.add('filtered-in');
          visibleCount++;
        } else {
          card.classList.remove('filtered-in');
        }
      });

      countEl.textContent = `Showing ${visibleCount} results`;

      currentPage = 1;
      mobileVisibleItems = ITEMS_PER_PAGE;
      paginate();
    }

    function paginate() {
      const allCards = Array.from(cards);
      const filteredCards = allCards.filter((card) => card.classList.contains('filtered-in'));
      const pagination = document.getElementById('pagination');

      const isMobile = window.innerWidth <= 600;

      // Hide all cards first
      allCards.forEach((card) => {
        card.style.display = 'none';
      });

      if (isMobile) {
        // Mobile Load More
        filteredCards.slice(0, mobileVisibleItems).forEach((card) => {
          card.style.display = 'block';
        });

        renderLoadMore(filteredCards.length);
      } else {
        // Desktop Pagination
        const totalPages = Math.ceil(filteredCards.length / ITEMS_PER_PAGE);

        const start = (currentPage - 1) * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        filteredCards.slice(start, end).forEach((card) => {
          card.style.display = 'block';
        });

        renderPagination(totalPages);
      }
    }

    function renderLoadMore(totalItems) {
      const pagination = document.getElementById('pagination');
      pagination.innerHTML = '';

      if (mobileVisibleItems >= totalItems) return;

      const loadMoreBtn = document.createElement('button');
      loadMoreBtn.classList.add('load-more-btn');
      loadMoreBtn.classList.add('my_btn');
      loadMoreBtn.textContent = 'Load More';

      loadMoreBtn.onclick = () => {
        mobileVisibleItems += ITEMS_PER_PAGE;
        paginate();
      };

      pagination.appendChild(loadMoreBtn);
    }

    function renderPagination(totalPages) {
      const pagination = document.getElementById('pagination');
      pagination.innerHTML = '';

      if (totalPages <= 1) return;

      // Prev Button
      if (currentPage > 1) {
        const prev = document.createElement('button');

        const img = document.createElement('img');
        img.src =
          'https://cdn.shopify.com/s/files/1/0831/8474/6530/files/right_1_942d16b4-4e09-48c5-bec9-23956115780d.png?v=1774533961';
        img.alt = 'Prev';
        img.style.width = '20px';

        prev.appendChild(img);

        prev.onclick = () => {
          currentPage--;
          paginate();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        };

        pagination.appendChild(prev);
      }

      // Page Numbers
      for (let i = 1; i <= totalPages; i++) {
        const btn = document.createElement('button');
        btn.textContent = i;

        if (i === currentPage) btn.classList.add('active');

        btn.onclick = () => {
          currentPage = i;
          paginate();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        };

        pagination.appendChild(btn);
      }

      // Next Button
      if (currentPage < totalPages) {
        const next = document.createElement('button');

        const img = document.createElement('img');
        img.src = 'https://cdn.shopify.com/s/files/1/0831/8474/6530/files/right_1.png?v=1774533495';
        img.alt = 'Next';
        img.style.width = '20px';

        next.appendChild(img);

        next.onclick = () => {
          currentPage++;
          paginate();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        };

        pagination.appendChild(next);
      }
    }

    // Collection from URL
    if (collectionParam) {
      const checkbox = document.querySelector(`.filter[value="${collectionParam}"]`);
      if (checkbox) checkbox.checked = true;
    }

    // Filter Events
    filterCheckboxes.forEach((filter) => {
      filter.addEventListener('change', applyFilters);
    });

    // Sorting
    document.querySelector('#sort').addEventListener('change', (e) => {
      const sortType = e.target.value;

      const items = Array.from(grid.children);

      items.sort((a, b) => {
        const priceA = parseFloat(a.dataset.price);
        const priceB = parseFloat(b.dataset.price);
        const dateA = parseInt(a.dataset.date);
        const dateB = parseInt(b.dataset.date);

        if (sortType === 'price-asc') return priceA - priceB;
        if (sortType === 'price-desc') return priceB - priceA;
        if (sortType === 'date-desc') return dateB - dateA;
        if (sortType === 'date-asc') return dateA - dateB;

        return 0;
      });

      items.forEach((item) => grid.appendChild(item));

      currentPage = 1;
      mobileVisibleItems = ITEMS_PER_PAGE;
      paginate();
    });

    // Re-run pagination on resize
    window.addEventListener('resize', () => {
      currentPage = 1;
      mobileVisibleItems = ITEMS_PER_PAGE;
      paginate();
    });

    // INIT
    applyFilters();
  });

  } catch(e) { console.error(e); }
})();
})();
